import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router-dom';
import Select from 'react-select';


import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import QuestionsChangeStatus from './Elements/QuestionsChangeStatus';

class QuestionsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      dados: [],
      lista_materias: [],
      lista_categorias: [],
      active: 0,
      question_id: 0,
      category_id: [],
      matter_id: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleSelectChangeMatter = this.handleSelectChangeMatter.bind(this);
    this.handleSelectChangeCategory = this.handleSelectChangeCategory.bind(this);

    this.loadData = this.loadData.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
    this.filterQuestions = this.filterQuestions.bind(this);
  }
  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Handlers
  handleSelectChangeMatter(name, event) {
    var change = {};
    this.setState({overlay: {message: '', type:'', status: 'open'}});
    if(event === null) {
      change[name] = null;
      this.loadData();
    } else {
      change[name] = event.value;
      this.setState({category_id: []});      
      this.filterCategoriesList(event.value);
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
      var change = {};
      if(event.length > 0) {
        change[name] = event;
      } else {
        change[name] = null;
      }
      this.setState(change);
      return event;
  }


  handleSelectChangeCategory(name, event) {
    var self = this;
    this.setState({overlay: {message: '', type:'', status: 'open'}});
    var handleSelectChange = this.handleSelectChange(name, event);
    Promise.resolve(handleSelectChange).then(function(event) {
      if(event.length > 0) {
        self.filterQuestions();
      } else if(self.state.matter_id !== null) {
        self.filterQuestions();
      } else if(self.state.matter_id === null) {
        self.loadData();
      } 
    });
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  
  filterQuestions() {
    var datasave = {
      matter_id: this.state.matter_id,
      category_id: this.state.category_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questoes/filtradas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questoes', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
      fetch(config.get('api') + '/materias/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).then(() => {
      fetch(config.get('api') + '/categorias/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({lista_categorias: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); }); }); 
    });
  }

  filterCategoriesList(matter_id) {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/categorias/lista/' + matter_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({lista_categorias: responseJson.data});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          self.filterQuestions();
        }
      }); 
    });
  }

  botaoEdicao (cell, row) {
    var url = '/questao/editar/' + cell;

    var dados = this.state.dados;
    var active = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        if (dado.active === "Sim") {
          active = 1;
        } else {
          active = 0;
        }
      }
    });
    return (
      <QuestionsChangeStatus handleAlert={this.handleAlert} active={active} url={url} question_id={cell} />
    );
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de questoes</h3>
      <Link to="/questao/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar questao</Link>
      <div className="clearfix"></div>
      <hr/>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Matérias:</label>
              <Select
                className="form-field-name"
                name="matter_id"
                value={this.state.matter_id}
                searchable={true}
                placeholder={'Selecionar Matéria'}
                onChange={this.handleSelectChangeMatter.bind(this, 'matter_id')}
                options={this.state.lista_materias}
              />    
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Categorias:</label>
              <Select
                className="form-field-name"
                name="category_id"
                value={this.state.category_id}
                searchable={true}
                multi={true}
                placeholder={'Selecionar Categorias'}
                onChange={this.handleSelectChangeCategory.bind(this, 'category_id')}
                options={this.state.lista_categorias}
              />    
          </div>
        </div>
      </div>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há questoes cadastrados', defaultSortName: 'questao', defaultSortOrder: 'ASC'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn hidden={true} dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Número</TableHeaderColumn>

        <TableHeaderColumn dataField="questao" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Questão</TableHeaderColumn>

        <TableHeaderColumn dataField="dificuldade" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Dificuldade</TableHeaderColumn>

        <TableHeaderColumn dataField="multiple_choice" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Múltipla escolha?</TableHeaderColumn>

        <TableHeaderColumn dataField="active" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Ativo?</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='110'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default QuestionsIndex;



// WEBPACK FOOTER //
// ./src/Components/Questions/QuestionsIndex.js